import angular from 'angular';
window.angular = angular;

import 'jquery';
import 'popper.js';
import 'bootstrap';

import './styles/main.scss';

import './app.module';

import './components/navbar/navbar.component';
import './components/slider/slider.component';
import "./components/intro/intro.component"
import "./components/ventajas/ventajas.component"
import './components/unete/unete.component';
import './components/beneficios/beneficios.component';
import './components/activar/activar.component';
import './components/negocio/negocio.component';
import './components/testimonios/testimonios.component';
import './components/descarga/descarga.component';
import './components/preguntas/preguntas.component';
import './components/modal/modal.component';
import './components/footer/footer.component';

angular.element(document).ready(() => {
  angular.bootstrap(document, ['Toke']);
});
